import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    question: 'Is it expensive to run?',
    answer: "Modern systems are very efficient. They use smart sensors to turn on ONLY when it's snowing and below freezing. For an average winter in Barrie, operating costs are often comparable to what you'd pay for a seasonal snow removal contract."
  }, {
    question: 'Can you install heating under an existing driveway?',
    answer: "In most cases, the driveway needs to be replaced to install the heating elements properly. However, we can sometimes retrofit systems depending on your current surface. The best time to install is when you're already planning to repave."
  }, {
    question: 'How long does installation take?',
    answer: 'The heating system installation itself usually takes 1-2 days. The total project time depends on the paving schedule, but typically a full driveway replacement with heating is completed within 3-5 days.'
  }, {
    question: 'What kind of maintenance is required?',
    answer: 'Electric systems are virtually maintenance-free with no moving parts. Hydronic (water-based) systems require an annual boiler check-up, similar to your home furnace. We offer maintenance packages for all our installations.'
  }, {
    question: 'How long do these systems last?',
    answer: 'Our heating cables and tubing are designed to last 30-50 years—often longer than the driveway surface itself. We use high-quality materials backed by industry-leading warranties.'
  }];
  return <section id="faq" className="py-16 bg-white md:py-24" data-id="element-281">
      <div className="container mx-auto px-4 md:px-6" data-id="element-282">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-283">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl" data-id="element-284">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-slate-600" data-id="element-285">
            Got questions? We have answers. Here are the most common things
            homeowners ask us.
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4" data-id="element-286">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-287" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border rounded-lg overflow-hidden" data-id="element-288">
      <button className="flex items-center justify-between w-full p-4 text-left bg-slate-50 hover:bg-slate-100 transition-colors" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen} data-id="element-289">
        <span className="font-medium text-slate-900" data-id="element-290">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-slate-500" data-id="element-291" /> : <ChevronDown className="h-5 w-5 text-slate-500" data-id="element-292" />}
      </button>
      <div className={`bg-white transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100 p-4 border-t' : 'max-h-0 opacity-0 overflow-hidden'}`} data-id="element-293">
        <p className="text-slate-600" data-id="element-294">{answer}</p>
      </div>
    </div>;
}